import { render } from "./MultiselectDetail.vue?vue&type=template&id=15d86a22"
import script from "./MultiselectDetail.vue?vue&type=script&lang=js"
export * from "./MultiselectDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__